<template>
    <div class='help'>
        <div class="help-warp">
            <ElRow class="title">
                <ElCol :span="24">
                    <p class="title-text" v-if="!isPartner">{{$t('help.helpWays')}}</p>
                    <div v-else>
                        <p class="title-text">{{$t('help.company')}}</p>
                        <p class="title-info"><strong>{{$t('help.helpContent')}}</strong></p>
                    </div>
                </ElCol>
            </ElRow>
            <template v-if="!isPartner">
                <div class="content">
                    <ElRow class="info-warp">
                        <template v-for="(item,index) in dataList">
                            <ElCol :xs="{span:20,push:2}" :sm="{span:22,push:1}" :md="24/isCol" :lg="24/isCol" :xl="24/isCol">
                                <div :key="index" class="content-warp">
                                    <h2 class="content-title">{{item.title}}</h2>
                                    <ul>
                                        <template v-for="(value,k) in item.list">
                                            <li :key="k" :class="{active: isClass && index==0, 'no-style': !value.title}">{{value.title}}</li>
                                            <ul v-if="value.list">
                                                <template v-for="l in value.list">
                                                    <li>{{l}}</li>
                                                </template>
                                            </ul>
                                        </template>
                                    </ul>
                                </div>
                            </ElCol>
                        </template>
                    </ElRow>
                </div>
            </template>
            <template v-else>
                <KllkForm :isTitle="false"></KllkForm>
            </template>
        </div>
    </div>
</template>
<script>
    import KllkForm from "../../../components/kllk-form-warp";

    export default {
        name: "help",
        props: {
            dataList: {
                type: Array,
                default: () => {
                    return []
                }
            },
            isPartner: {
                type: Boolean,
                default: false
            },
            // 医学事务帮助我们，左侧颜色标黑
            isClass: {
                type: Boolean,
                default: false
            }
        },
        components: {KllkForm},
        computed: {
            isCol() {
                return this.dataList.length > 4 ? 3 : this.dataList.length;
            }
        }
    }
</script>
<style lang='less' scoped>
    @import "../../../style/constant.less";

    .help {
        background-image: url('../../../assets/service/help.jpg');
        padding: 100px 0;
        background-attachment: fixed;

        .help-warp {
            max-width: @page-width;
            margin: 0 auto;

            .title {
                text-align: center;
                font-weight: 300;

                .title-text {
                    font-size: 28px;
                    font-weight: 500;
                    line-height: 54px;
                    font-style: normal;
                    text-align: center;
                    color: @title-color;
                    margin-bottom: 20px;
                }
                @media screen and (min-width: 320px) and (max-width: 480px) {
                    .title-text{
                        font-size:24px;
                    }
                }
                .title-info {
                    font-size: 21px;
                    margin-top: 30px;
                }
            }

            .content {
                .content-warp {
                    min-width: 25%;
                    max-width: 100%;
                    padding: 0 10px;
                    color: @content-color;
                    min-height: 100px;

                    .content-title {
                        font-size: 21px;
                        font-weight: 500;
                        color: @title-color;
                    }
                     @media screen and (min-width: 320px) and (max-width: 480px) {
                        .content-title{
                            font-size:18px;
                        }
                    }
                    ul {
                        padding-inline-start: 17px;

                        li {
                            font-size: 15px;
                            margin: 5px 0;
                            padding: 3px 0;
                        }
                        // 这里是为了教育培训和中心业务发展及推广对齐
                        .no-style {
                            list-style: none;
                            height: 28px;
                        }
                        .active {
                            font-weight: 500;
                            color: #333;
                            list-style: none;
                            font-size: 1.5em;
                        }
                    }
                }

                @media screen and (min-width: 320px) and (max-width: 480px) {
                .active {
                    font-size: 18px !important;
                    margin-left: -17px !important;
                }
            }
            }
        }
    }
</style>